import React, { useEffect } from 'react';
import styled from 'styled-components';

import close_img from '../../assets/close.svg';

interface PictureModalProps {
  onClose: () => void;
  zIndex?: number;
  canClose?: boolean;
  closeOnOutsideClick?: boolean;
  children: React.ReactNode;
}

const CarouselPictureModal = ({
  onClose,
  zIndex = 200,
  canClose = true,
  closeOnOutsideClick = true,
  children,
}: PictureModalProps) => {

  const handleKeyPress = (evt: KeyboardEvent) => {
    if (evt.keyCode === 27 && canClose) {
      onClose();
    }
  };

  const disableScroll = (e: Event) => {
    e.preventDefault();
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
    document.body.style.overflow = 'hidden';
    document.addEventListener("touchmove", disableScroll, { passive: false });
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
      document.body.style.overflow = 'auto';
      document.removeEventListener("touchmove", disableScroll);
    };
  }, []);

  return (
    <Wrapper zIndex={zIndex}
             onClick={closeOnOutsideClick ? onClose : undefined}>
      <Box onClick={(e) => e.stopPropagation()}>
        {canClose && (
          <TopBox>
            <CloseIcon alt="close" src={close_img} onClick={onClose} />
          </TopBox>
        )}
        {/* @ts-ignore */}
        <ContentPlaceholder>{children}</ContentPlaceholder>
      </Box>
    </Wrapper>
  );
};

export default CarouselPictureModal;

const Wrapper = styled.div<{ zIndex?: number }>`
  position: fixed;
  z-index: ${(props) => props.zIndex || 10};
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(51, 51, 51, 0.95);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  overflow: hidden;
  justify-content: center;
  cursor: pointer;
`;

const Box = styled.div`
  box-sizing: border-box;
  color: white;
  border-radius: 12px;
  cursor: default;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: min(calc(100vw - 48px), calc(100vh - 48px));
  max-height: min(calc(100vw - 48px), calc(100vh - 48px));
  width: fit-content;
  height: fit-content;
`;

const TopBox = styled.div`
  position: absolute;
  right: 24px;
  top: 24px;
`;

const CloseIcon = styled.img`
  width: 32px;
  height: 32px;
  cursor: pointer;

  @media (max-width: 720px) {
    z-index: 110;
  }
`;

const ContentPlaceholder = styled.div`
  font-family: Nunito Sans;
`;
